import { gql } from '@apollo/client';

/**
 * GraphQL mutation to delete a standard policy
 */
export const DELETE_STANDARD_POLICY = gql`
  mutation DeleteStandardPolicy($input: DeleteStandardPolicyInput!) {
    deleteStandardPolicy(input: $input)
  }
`;
